'use client';

import Script from 'next/script';
import { GTM_JS_PATH } from '@/public/Constants/EnumConstants';

export default function DynamicScripts() {
    const isProduction = process.env.NEXT_PUBLIC_ENV === "production";

    return (
        <>
            {isProduction && (
                <>
                    <Script async strategy="lazyOnload">
                        {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', {
                page_path: window.location.pathname,
                });
            `}
                    </Script>
                    {/* <Script src={HOTJAR_JS_PATH} strategy="lazyOnload" /> */}
                    <Script
                        async
                        strategy="lazyOnload"
                        type="text/javascript"
                        src="https://smartarget.online/loader.js?u=d86add168ecd07a508bb7fa155526fdc751161f3"
                    />
                    <Script
                        async
                        id="hs-script-loader"
                        strategy="lazyOnload"
                        type="text/javascript"
                        src="//js-eu1.hs-scripts.com/143182740.js"
                    />
                </>
            )}
            {/* 3. Google Tag Manager script injected lazily */}
            <Script
                async
                strategy="lazyOnload"
                id="gtm-script"
                src={GTM_JS_PATH}
            />
            <Script
                async
                strategy="lazyOnload"
                src="https://widget.cloudinary.com/v2.0/global/all.js"
                type="text/javascript"
            />
        </>
    );
}
